'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeTableIcon = function TraceTypeTableIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M8 8h16v6H8z' }),
        _react2.default.createElement('path', { fill: '#fff', d: 'M8 14h16v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M8 20h16v6H8z' }),
        _react2.default.createElement('path', { fill: '#fff', d: 'M8 26h16v6H8z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M8 32h16v6H8zM26 8h12v6H26z' }),
        _react2.default.createElement('path', { fill: '#fff', d: 'M26 14h12v6H26z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M26 20h12v6H26z' }),
        _react2.default.createElement('path', { fill: '#fff', d: 'M26 26h12v6H26z' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M26 32h12v6H26z' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#25fdfc', d: 'M21 11H11m10 12H11', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M21 17H11m10 12H11', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#25fdfc', d: 'M21 35H11m24-24h-6m6 12h-6', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M35 17h-6m6 12h-6', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#25fdfc', d: 'M35 35h-6', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('path', { fill: '#1d9bfb', d: 'M24 8h2v30h-2z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M24 8h2v6h-2zm0 12h2v6h-2zm0 12h2v6h-2z' })
    );
};

exports.default = TraceTypeTableIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeTableIcon.js
// module id = 733
// module chunks = 0